import {AppUser} from "../../../models/app";
import {ProprietarioObject} from "../../../models/Proprietario";
import React from "react";
import {pluralize} from "../../../lib/utils";
import {IonList} from "@ionic/react";
import CardProprietario from "./CardProprietario";
import {FazendaIndexProprietario} from "../../../lib/DataHooks/fazendas";

interface BuscaResultadosProps {
  user: AppUser;
  found: ProprietarioObject[];
  total?: number;
  onSelect?: (prop: ProprietarioObject) => void;
  indexProprietarios?: FazendaIndexProprietario;
}


const BuscaResultados: React.FC<BuscaResultadosProps> = (props) => {
  const {found, onSelect, user, indexProprietarios} = props;
  const total = props.total || found.length;

  return (
    <>
      <div className={'text-sm opacity-50'}>
        {total} {pluralize('proprietário', total)} {pluralize('encontrado', total)}
        {total > found.length &&
          <span> (exibindo apenas os {found.length} primeiros registros)</span>
        }
      </div>
      <IonList>
        {found.map((p) => (
          <CardProprietario
            key={p.id}
            user={user}
            instance={p}
            onClick={!!onSelect ? () => onSelect(p) : undefined}
            numFazendas={indexProprietarios && indexProprietarios[p.id] ? indexProprietarios[p.id].length : undefined}
          />
        ))}
      </IonList>
    </>
  )
}

export default BuscaResultados;